type IconProps = React.ComponentProps<'svg'>

export function User01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M11.25 12.5C12.591 12.5 13.4279 12.4915 14.129 12.7041C15.6471 13.1646 16.8354 14.353 17.2959 15.8711C17.5086 16.5722 17.5 17.409 17.5 18.75C17.5 19.1642 17.1643 19.5 16.75 19.5C16.3359 19.5 16 19.1642 16 18.75C16 17.3 15.9922 16.7411 15.8604 16.3066C15.5453 15.2679 14.7321 14.4547 13.6934 14.1396C13.2589 14.0079 12.7 14 11.25 14H6.25005C4.80011 14 4.24116 14.0079 3.80669 14.1396C2.76801 14.4547 1.95478 15.268 1.6397 16.3066C1.50794 16.7411 1.50005 17.3 1.50005 18.75C1.50005 19.1642 1.16426 19.5 0.750047 19.5C0.335856 19.5 4.72899e-05 19.1642 4.72899e-05 18.75C4.72899e-05 17.4091 -0.00849794 16.5722 0.204149 15.8711C0.664658 14.353 1.85306 13.1646 3.37114 12.7041C4.07221 12.4915 4.90912 12.5 6.25005 12.5H11.25Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75005 0C11.6495 0 14 2.3505 14 5.25C14 8.1495 11.6495 10.5 8.75005 10.5C5.85057 10.5 3.50005 8.14948 3.50005 5.25C3.50005 2.35052 5.85057 2.5642e-05 8.75005 0ZM8.75005 1.5C6.679 1.50003 5.00005 3.17895 5.00005 5.25C5.00005 7.32105 6.679 8.99997 8.75005 9C10.8211 9 12.5 7.32107 12.5 5.25C12.5 3.17893 10.8211 1.5 8.75005 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
